<template>
  <CCard border-color="primary">
    <CCardHeader @click="collapsed = !collapsed">
      <CIcon :name="collapsableIcon" v-if="collapsable" />
      {{ config.title }}
      <div v-if="!collapsed" class="card-header-actions">
        <CButton
          variant="outline"
          color="primary"
          size="sm"
          v-on:click.stop="dataForm.active = !dataForm.active"
          ><CIcon name="cil-pencil" />&nbsp;{{
            $t("common.edit_label")
          }}</CButton
        >
      </div>
    </CCardHeader>
    <CCardBody v-if="!collapsed">
      <FormFlat :config="config" :dataForm="dataForm" v-on="$listeners" />
    </CCardBody>
    <CCardFooter v-if="dataForm.active && !collapsed">
      <vue-ladda
        :loading="dataForm.loading"
        data-style="zoom-in"
        button-class="btn btn-primary btn-sm"
        @click.prevent="SaveData"
        ><CIcon name="cil-save" />&nbsp;{{ $t("common.save_label") }}</vue-ladda
      >
    </CCardFooter>
  </CCard>
</template>

<script>
import FormFlat from "./FormFlat";

var _ = require("lodash");

/*!
 * Find the differences between two objects and push to a new object
 * (c) 2019 Chris Ferdinandi & Jascha Brinkmann, MIT License, https://gomakethings.com & https://twitter.com/jaschaio
 * @param  {Object} obj1 The original object
 * @param  {Object} obj2 The object to compare against it
 * @return {Object}      An object of differences between the two
 */
var diff = function (obj1, obj2) {
  // Make sure an object to compare is provided
  if (!obj2 || Object.prototype.toString.call(obj2) !== "[object Object]") {
    return obj1;
  }

  //
  // Variables
  //

  var diffs = {};
  var key;

  //
  // Methods
  //

  /**
   * Check if two arrays are equal
   * @param  {Array}   arr1 The first array
   * @param  {Array}   arr2 The second array
   * @return {Boolean}      If true, both arrays are equal
   */
  var arraysMatch = function (arr1, arr2) {
    // Check if the arrays are the same length
    if (arr1.length !== arr2.length) return false;

    // Check if all items exist and are in the same order
    for (var i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }

    // Otherwise, return true
    return true;
  };

  /**
   * Compare two items and push non-matches to object
   * @param  {*}      item1 The first item
   * @param  {*}      item2 The second item
   * @param  {String} key   The key in our object
   */
  var compare = function (item1, item2, key) {
    // Get the object type
    var type1 = Object.prototype.toString.call(item1);
    var type2 = Object.prototype.toString.call(item2);

    // If type2 is undefined it has been removed
    if (type2 === "[object Undefined]") {
      diffs[key] = null;
      return;
    }

    // If items are different types
    if (type1 !== type2) {
      diffs[key] = item2;
      return;
    }

    // If an object, compare recursively
    if (type1 === "[object Object]") {
      var objDiff = diff(item1, item2);
      if (Object.keys(objDiff).length > 0) {
        diffs[key] = objDiff;
      }
      return;
    }

    // If an array, compare
    if (type1 === "[object Array]") {
      if (!arraysMatch(item1, item2)) {
        diffs[key] = item2;
      }
      return;
    }

    // Else if it's a function, convert to a string and compare
    // Otherwise, just compare
    if (type1 === "[object Function]") {
      if (item1.toString() !== item2.toString()) {
        diffs[key] = item2;
      }
    } else {
      if (item1 !== item2) {
        diffs[key] = item2;
      }
    }
  };

  //
  // Compare our objects
  //

  // Loop through the first object
  for (key in obj1) {
    compare(obj1[key], obj2[key], key);
  }

  // Loop through the second object and find missing items
  for (key in obj2) {
    if (!obj1[key] && obj1[key] !== obj2[key]) {
      diffs[key] = obj2[key];
    }
  }

  // Return the object of differences
  return diffs;
};

export default {
  name: "FormCard",
  props: ["config"],
  data() {
    return {
      collapsed: this.config.collapsed || false,
      baseDataForm: {
        loading: false,
        active: this.config.active || false,
        // body: this.config.body,
        errors: {},
        // dataOrig: Object.assign({}, this.config.data),
        // dataOrigOptions: Object.assign({}, this.config.options),
        dataOrig: {}, //JSON.parse(JSON.stringify(this.config.data)),
        // dataOrigOptions: JSON.parse(JSON.stringify(this.config.options)),
        // formData: this.config.data,
        // formDataOptions: this.config_options,
      },
    };
  },
  computed: {
    collapsable() {
      return typeof this.config.collapsed !== "undefined";
    },
    collapsableIcon() {
      console.log("collapsed", this.collapsed);
      if (this.collapsed) {
        return "cil-chevron-right";
      } else {
        return "cil-chevron-bottom";
      }
    },
    dataForm() {
      let res = this.baseDataForm;
      res.formData = this.config.data;
      res.formDataOptions = this.config.options;
      return res;
    },
  },
  // mounted() {
  //   this.basedata = Object.assign({}, this.config.data);
  // },
  watch: {
    "baseDataForm.active": function (Nv, Ov) {
      console.log("active form", Nv, Ov);
      if (Nv) {
        console.log("Create copy");
        this.baseDataForm.dataOrig = JSON.parse(
          JSON.stringify(this.config.data)
        );
      } else {
        console.log("restore copy", this.baseDataForm.dataOrig);
        this.config.data = this.baseDataForm.dataOrig;
        console.log("restore copy", this.config.data);
      }
    },
  },
  methods: {
    SaveData() {
      // set form state
      this.dataForm.loading = true;
      this.dataForm.errors = {};
      // console.log(this.$store.state.role.id)

      // // generate base data
      // let dataForm = this.config.fields.reduce(function (map, obj) {
      //   if (typeof obj.new_value !== "undefined" && !obj.translate) {
      //     map[obj.name] = obj.new_value;
      //   }

      //   return map;
      // }, {});
      // console.log(dataForm);
      // // add translations
      // let base_data = null;

      // if (Object.keys(trans).length>0) {
      //   let tfields = this.config.fields.reduce(function (map, obj) {
      //     if (obj.new_value && obj.translate) {
      //       map.push(obj.name);
      //       if (!base_data) {
      //         base_data = obj.value;
      //       }
      //     }
      //     return map;
      //   }, []);
      //   console.log("fields", tfields);
      //   let langs = this.config.fields.reduce(function (map, obj) {
      //     if (obj.new_value && obj.translate) {
      //       let l = Object.keys(obj.new_value);

      //       l.forEach((element) => map.push(element));
      //     }
      //     return map;
      //   }, []);
      //   langs = [...new Set(langs)];
      //   console.log("langs", langs);

      //   base_data = JSON.parse(JSON.stringify(base_data));
      //   Object.keys(base_data).forEach(function (l) {
      //     // console.log(l, langs, langs.includes(l));
      //     if (langs.includes(l)) {
      //       Object.keys(base_data[l]).forEach(function (f) {
      //         if (!tfields.includes(f)) {
      //           delete base_data[l][f];
      //         }
      //       });
      //     } else {
      //       delete base_data[l];
      //     }
      //   });
      //   console.log("base", base_data);

      //   dataForm.translations = _.merge(base_data, trans);
      //   console.log(dataForm);
      // }
      // // add id
      // dataForm.id = this.config.obj_id;
      // console.log(dataForm);
      let self = this;
      // function ParseCInputCheckbox(fields) {
      //   fields.forEach(function (f) {
      //     if (f.type == "CInputCheckbox") {
      //       let values = self.config.options[f.options].reduce(function (
      //         map,
      //         obj
      //       ) {
      //         if (obj.checked) {
      //           map.push(obj.value);
      //         }
      //         return map;
      //       },
      //       []);
      //       self.dataForm.formData[f.name] = values;
      //     }else if (f.children){
      //       ParseCInputCheckbox(f.children)
      //     }
      //   });
      // }
      // ParseCInputCheckbox(this.config.fields)
      this.config.fields.forEach(function (f) {
        if (f.type == "CInputCheckbox") {
          let values = self.config.options[f.options].reduce(function (
            map,
            obj
          ) {
            if (obj.checked) {
              map.push(obj.value);
            }
            return map;
          },
          []);
          self.dataForm.formData[f.name] = values;
        }
      });

      let params = diff(this.dataForm.dataOrig, this.dataForm.formData);
      params.id = this.dataForm.dataOrig.id;
      delete params.ts_created;
      delete params.ts_modified;
      // console.log(params);
      let trans = this.config.fields.reduce(function (map, obj) {
        if (obj.translate) {
          var tfield = {};
          tfield[obj.translate] = [obj.name];
          map = _.mergeWith(map, tfield, function (objValue, srcValue) {
            if (_.isArray(objValue)) {
              return objValue.concat(srcValue);
            }
          });
        }
        return map;
      }, {});
      // console.log(trans);

      Object.keys(params).forEach(function (key) {
        if (Object.keys(trans).includes(key)) {
          // console.log("CCCC", key, params[key]);
          Object.keys(params[key]).forEach(function (mkey) {
            // console.log("MMMM", mkey)
            trans[key].forEach(function (vkey) {
              // console.log(key, mkey, vkey)
              // console.log(params[key][mkey][vkey])
              if (!params[key][mkey][vkey]) {
                // console.log(params[key][mkey][vkey])
                // console.log(self.dataForm.dataOrig[key][mkey][vkey])
                params[key][mkey][vkey] =
                  self.dataForm.dataOrig[key][mkey][vkey];
              }
            });
          });
        }
      });

      // console.log(params);
      this.config.dm.update("", params).then(
        (e) => {
          // console.log("after update");
          // console.log(e);
          // this.$emit("data_updated", e);
          this.dataOrigOptions = JSON.parse(
            JSON.stringify(this.dataForm.formDataOptions)
          );
          this.baseDataForm.dataOrig = e;
          this.$emit("data_updated", e);
          this.dataForm.loading = false;
          this.dataForm.active = false;
          this.$store.dispatch("toaster/add", {
            title: this.$t("user.profile.data.ok.title"),
            text: this.$t("user.profile.data.ok.message"),
            autohide: true,
          });
        },
        (reason) => {
          let errors = JSON.parse(reason[0].error.response);
          this.dataForm.errors = errors;
          this.dataForm.loading = false;
        }
      );
    },
  },
  components: {
    FormFlat,
  },
};
</script>
